

<div class="section" id="about">
    <div class="container">
      <div class="card" data-aos="fade-up" data-aos-offset="10">
        
            <div class="card-body">
              <h3 class="h3">About Me</h3>
              <img src="assets/images/about.png" class="center" style="height: 310px; width:auto; margin-bottom: 3%;">
              <p>
                Have you been thinking about PSYCHOTHERAPY OR COUNSELING? To have a safe, quiet, relaxing nonjudgmental environment to explore who you are, what you want, where you are going, and how you will get there? Well, look no further I'm the Mental Health professional you have been looking for (Counselor, Psychotherapist, Psychiatric Social Worker, Psychologist, Sociologist, Criminologist, and Hypnotherapist). 
              </p><br><p>
                I strive to create a relaxing, non judgemantal environment to explore who you are, what you want, and how to get there. I am an open minded, understanding therapist/hypnotherapist offering individual, couple and family counseling to anyone who needs help improving their life. As a generalist, I work with ALL people with Every concern. I provide supervision to students in the counseling/SW field as well as private and group tutoring at Orchard School and Orchard Center for Psychotherapy.
              </p><br>
              <p>
                Credentials: BA: Psychology and Sociology; MA: Counseling, Human Services and Guidance-concentration on individual counseling with an integrative client centered, humanistic, and electric approach; MSW, LCSW: Social Work-Concentration children and families with an integrative psychodynamic, cognitive behavioral, and electric approach AND ALSO a National Boad Certified Fellow in Clinical Hypnotherapy (NBCFCH) and Criminologist certified by Rutgers University.
              </p>
              <br>
              <p>
                Find me on <a href="https://www.psychologytoday.com/us/therapists/tracie-a-sarkar-west-caldwell-nj/42991">Psychology Today</a>
              </p>
              <img src="assets/images/rutgers.jpeg" class="center">

              <div><a href="https://www.psychologytoday.com/us/therapists/tracie-a-sarkar-west-caldwell-nj/42991"><img src="assets/images/psychology_today.png" width="50%" class="center"></a></div>



            </div>


      </div>
    </div>
</div>